export { PhoneMissedCall as default } from './PhoneMissedCall';
